(function () {
  var injected = false;

  function run() {
    var inbox = document.querySelector('inbox-online-store-chat');
    var wa = document.getElementById('nm-whatsapp');
    if (!inbox) { requestAnimationFrame(run); return; }

    var h = inbox.getBoundingClientRect().height;
    document.body.classList.toggle('inbox-chat-open', h > 100);

    if (!injected && inbox.shadowRoot) {
      var s = document.createElement('style');
      s.textContent = '@media (max-width: 999px) { :host { bottom: 140px !important; } }';
      inbox.shadowRoot.appendChild(s);
      injected = true;
    }

    if (wa && h <= 100 && window.innerWidth < 1000) {
      var inboxRect = inbox.getBoundingClientRect();
      var inboxCenter = inboxRect.top + inboxRect.height / 2;
      var waHeight = wa.getBoundingClientRect().height;
      wa.style.setProperty('top', (inboxCenter - waHeight / 2) + 'px', 'important');
      wa.style.setProperty('bottom', 'auto', 'important');
    } else if (wa) {
      wa.style.removeProperty('top');
      wa.style.removeProperty('bottom');
    }

    requestAnimationFrame(run);
  }

  if (document.readyState === 'complete') {
    requestAnimationFrame(run);
  } else {
    window.addEventListener('load', function () { requestAnimationFrame(run); });
  }
})();
